/**
 * Redux slice for the guided onboarding tour (Patients board).
 * Three surfaces share one manifest (components/GuidedOnboarding/tourSteps.js):
 *   - linear tour (mode 'linear', walks stepIndex through the manifest)
 *   - JIT first-use coach-marks (mode 'jit', shows a single jitStepId)
 *   - reminders (driven by backend TourProgress; not stored here)
 * Components read via the selectors at the bottom (react-redux v6 -> connect()).
 */
export const TOUR_START = 'guidedOnboarding/START'
export const TOUR_NEXT = 'guidedOnboarding/NEXT'
export const TOUR_PREV = 'guidedOnboarding/PREV'
export const TOUR_GOTO = 'guidedOnboarding/GOTO'
export const TOUR_EXIT = 'guidedOnboarding/EXIT'
export const TOUR_COMPLETE = 'guidedOnboarding/COMPLETE'
export const TOUR_SET_DEMO = 'guidedOnboarding/SET_DEMO'
export const TOUR_JIT = 'guidedOnboarding/JIT'

const initialState = {
  active: false,
  mode: 'linear',     // 'linear' | 'jit'
  stepIndex: 0,
  jitStepId: null,
  demoActive: false,  // when true, the patient board fetch includes the demo row
  tourName: null,     // which tour is active (e.g. 'insurance_verification' | 'ftc_tasks')
  status: 'idle'      // 'idle' | 'running' | 'completed'
}

export function guidedOnboarding (state = initialState, action) {
  switch (action.type) {
    case TOUR_START:
      return { ...state, active: true, mode: 'linear', stepIndex: action.atIndex || 0, jitStepId: null, demoActive: true, tourName: action.tourName || state.tourName, status: 'running' }
    case TOUR_NEXT:
      return { ...state, stepIndex: state.stepIndex + 1 }
    case TOUR_PREV:
      return { ...state, stepIndex: Math.max(0, state.stepIndex - 1) }
    case TOUR_GOTO:
      return { ...state, stepIndex: action.index }
    case TOUR_JIT:
      return { ...state, active: true, mode: 'jit', jitStepId: action.stepId, status: 'running' }
    case TOUR_EXIT:
      return { ...state, active: false, mode: 'linear', jitStepId: null, status: 'idle' }
    case TOUR_COMPLETE:
      return { ...state, active: false, mode: 'linear', jitStepId: null, demoActive: false, status: 'completed' }
    case TOUR_SET_DEMO:
      return { ...state, demoActive: action.value }
    default:
      return state
  }
}

// action creators
export const startTour = (atIndex = 0, tourName = null) => ({ type: TOUR_START, atIndex, tourName })
export const nextStep = () => ({ type: TOUR_NEXT })
export const prevStep = () => ({ type: TOUR_PREV })
export const gotoStep = (index) => ({ type: TOUR_GOTO, index })
export const exitTour = () => ({ type: TOUR_EXIT })
export const completeTour = () => ({ type: TOUR_COMPLETE })
export const setDemo = (value) => ({ type: TOUR_SET_DEMO, value })
export const showJitStep = (stepId) => ({ type: TOUR_JIT, stepId })

// selectors (UI must only read through these)
export const selectTourActive = (s) => s.guidedOnboarding.active
export const selectTourMode = (s) => s.guidedOnboarding.mode
export const selectStepIndex = (s) => s.guidedOnboarding.stepIndex
export const selectJitStepId = (s) => s.guidedOnboarding.jitStepId
export const selectDemoActive = (s) => s.guidedOnboarding.demoActive
export const selectTourName = (s) => s.guidedOnboarding.tourName
